import * as THREE from 'three';
import { Scene } from '../viewer/Scene';

export class Orthophoto extends THREE.Object3D {
  mesh: THREE.Mesh;
  identifier: string;
  initialised = false;
  scene: Scene;
  constructor(identifier: string, elevation: number, scene: Scene) {
    super();
    this.identifier = identifier;
    this.mesh = new THREE.Mesh();
    this.visible = false;
    this.scene = scene;
    this.position.z = elevation;
  }

  initialise(parameters: { visible: boolean; width: number; height: number; origin: number[]; scale: number[]; elevation: number; data: Uint8Array | Uint8ClampedArray | number[] }) {
    const textureData = Array.isArray(parameters.data) ? new Uint8Array(parameters.data) : parameters.data;
    const texture = new THREE.DataTexture(textureData, parameters.width, parameters.height, THREE.RGBAFormat);
    texture.needsUpdate = true;
    const geometry = new THREE.PlaneGeometry(parameters.width * parameters.scale[0], parameters.height * parameters.scale[1]);
    const material = new THREE.MeshBasicMaterial({ map: texture, transparent: true, side: THREE.BackSide });
    this.mesh = new THREE.Mesh(geometry, material);
    this.add(this.mesh);
    this.visible = parameters.visible;
    this.position.set(parameters.origin[0] + (parameters.width * parameters.scale[0]) / 2.0, parameters.origin[1] + (parameters.height * parameters.scale[1]) / 2.0, parameters.elevation);
    this.initialised = true;

    this.scene.dispatchEvent({
      type: 'orthophoto_initialised',
    });
  }

  setElevation(elevation: number) {
    this.position.z = elevation;
  }
}
